// extracted by mini-css-extract-plugin
export default {"Root":"ConnectCredentialsRoute_Root__XPOEt"};